// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__5wsod","filters_close":"FiltersBlock_filters_close__ZmrdX"};